import { render, staticRenderFns } from "./StoreOwnerChange.vue?vue&type=template&id=0abbb50e&scoped=true&"
import script from "./StoreOwnerChange.vue?vue&type=script&lang=js&"
export * from "./StoreOwnerChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abbb50e",
  null
  
)

export default component.exports